@if ((turnoverRiskService.series$ | async); as series) { @if (settings &&
series[0]?.data.length > 0) {
<div id="turnover-risk-chart" data-cy="turnover-risk-chart">
  <apx-chart
    #turnoverRiskChart
    [series]="series"
    [chart]="settings.chart"
    [xaxis]="settings.xAxis"
    [tooltip]="settings.toolTip"
    [dataLabels]="settings.dataLabels"
    [markers]="settings.markers"
    [grid]="settings.grid"
    [yaxis]="settings.yAxis"
    [colors]="settings.colors"
    [plotOptions]="settings.plotOptions"
    [states]="settings.states"
    [legend]="{show: false}"
  ></apx-chart>
</div>
} @if (turnoverRiskService.loading$ | async) {
<mat-spinner></mat-spinner>
} }
